module.exports = __webpack_public_path__ + "static/media/161007-DSC05131-30_Small.de37c5ee.jpg";